import { createRouter, createWebHistory } from 'vue-router';

import NProgress from 'nprogress';
import moment from 'moment-timezone';

import { G } from "@/_common";

import { main_routes } from "./routes";
import { user_routes } from "@/_routes";


export const routesObj = {};
main_routes.forEach(e => {
    routesObj[e.name] = e;
});
user_routes.forEach(e => {
    routesObj[e.name] = e;
});

// export const routes = [
//     ...main_routes,
//     ...user_routes,
// ];

export const routes = Array.from([...main_routes, ...user_routes]
    .reduce((m, o) => m.set(o.name, o), new Map)
    .values()
);

const router = createRouter({
    // history: createWebHistory(process.env.BASE_URL),
    // history: createWebHashHistory(),
    history: createWebHistory(),
    base: '',
    // base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 }
    }
});

router.beforeEach((to, from, next) => {
    var tokenAuth = false;
    var adminRole = false;

    if( G.dynModal.components.length ){
        G.closeModalAll();
    }

    if( G.hasClientData("DA_AUTH_TOKEN") ){
        const data = G.getClientData("DA_AUTH_TOKEN").split(".");
        const payload = JSON.parse(atob(data[0]));
        const expires = JSON.parse(atob(data[1]));

        // if (moment(expires.exp, 'DD/MM/YYYY hh:mm:ss') < moment()) {

        // console.log(expires.exp, moment.utc(expires.exp).format(G.datetime_format['pg_datetime']), moment.utc(expires.exp).format(G.datetime_format['pg_datetime']), moment.utc().format(G.datetime_format['pg_datetime']), moment.utc(expires.exp) < moment.utc());

        if( moment.utc(expires.exp) < moment.utc() ) {
            G.removeClientData("DA_AUTH_TOKEN");
            tokenAuth = false;
            G.alert.warning({toast: true, position: 'center', msg: 'Aktiv sessiyanın vaxtı bitib !'});
        }
        else if( moment.utc(expires.exp) > moment.utc() ) tokenAuth = true;

        if (payload.role == 'admin' || payload.role == 'sysadmin') {
            adminRole = true;
        }
    }

    console.log("tokenAuth", tokenAuth);
    console.log("!to.matched.some(record => record.name == 'login')", !to.matched.some(record => record.name == 'login') );
    console.log("to.matched.some(record => record.meta.requireAuth)", to.matched.some(record => record.meta.requireAuth));
    console.log("to.matched.some(record => (record.meta.requireAuth !== undefined && record.meta.requireAuth == true))", to.matched.some(record => (record.meta.requireAuth !== undefined && record.meta.requireAuth == true)));


    console.log("( ( to.matched[0].meta.requireNone === undefined || to.matched[0].meta.requireNone != true ) && ( tokenAuth && !to.matched.some(record => record.name == 'login') && !G.getUserAccessToMenu( to.matched[0].name ) ) )", ( ( to.matched[0].meta.requireNone === undefined || to.matched[0].meta.requireNone != true ) && ( tokenAuth && !to.matched.some(record => record.name == 'login') && !G.getUserAccessToMenu( to.matched[0].name ) ) ));
    console.log("(!to.matched.some(record => record.name == 'login') && ( to.matched.some(record => (record.meta.requireAuth !== undefined && record.meta.requireAuth == true)) || to.matched.some(record => (record.meta.requireAuth === undefined )) ) && !tokenAuth)", (!to.matched.some(record => record.name == 'login') && ( to.matched.some(record => (record.meta.requireAuth !== undefined && record.meta.requireAuth == true)) || to.matched.some(record => (record.meta.requireAuth === undefined )) ) && !tokenAuth));
    console.log("(!to.matched.some(record => record.name == 'login') && ( to.matched.some(record => (record.meta.requireAuth !== undefined && record.meta.requireAuth == true)) || to.matched.some(record => (record.meta.requireAuth === undefined )) ) && !tokenAuth)", (!to.matched.some(record => record.name == 'login') && ( to.matched.some(record => (record.meta.requireAuth !== undefined && record.meta.requireAuth == true)) || to.matched.some(record => (record.meta.requireAuth === undefined )) ) && !tokenAuth));
    console.log();


    if( ( to.matched[0].meta.requireNone === undefined || to.matched[0].meta.requireNone != true ) && ( tokenAuth && !to.matched.some(record => record.name == 'login') && !G.getUserAccessToMenu( to.matched[0].name ) ) ){
        console.log('1', to);
        next({
            name: 'notfound',
        });
        // return;
    }

    // if ( !to.matched.some(record => record.name == 'login') && ((to.matched.some(record => record.meta.requireAdmin) && !adminRole && !tokenAuth) || (to.matched.some(record => record.meta.requireAuth) && !tokenAuth)) ) {

    else if (!to.matched.some(record => record.name == 'login') && ( to.matched.some(record => (record.meta.requireAuth !== undefined && record.meta.requireAuth == true)) || to.matched.some(record => (record.meta.requireAuth === undefined )) ) && !tokenAuth) {
        console.log('2', to);
        next({
            // path: '/az/login',
            name: 'login',
            query: { redirect: to.fullPath },
            // query: { redirect: to.query.redirect },
            // params: {lang: to.params.lang},
        });
    }

    else if (!to.matched.some(record => record.name == 'login') && to.matched.some(record => record.meta.requireAdmin !== undefined && record.meta.requireAdmin == true) && !adminRole) {
        console.log('3', to);
        next({
            name: 'notperm',
            // params: { lang: to.params.lang },
        });
    }

    // else if (!to.matched.some(record => record.name == 'login') && to.matched.some(record => record.meta.requireAuth === undefined || record.meta.requireAuth != false) && !tokenAuth) {
    //     next({
    //         name: 'login',
    //         // params: { lang: to.params.lang },
    //         query: { redirect: to.fullPath }
    //     });
    // }

    // else if (!to.matched.some(record => record.name == 'login') ) {
    //     let rf = from.fullPath.split('/');
    //     let rt = to.fullPath.split('/');
    //     if (rf.length > 0 && rf[1].length == 2 && rf[1] != rt[1]) {
    //         rf[1] = rt[1];

    //         let translatedPath = rf.join('/') ;
    //         from.fullPath = translatedPath;
    //         from.path = translatedPath;
    //         from.href = translatedPath;
    //         next({ path: translatedPath, query: to.query, hash: to.hash, params: {lang: to.params.lang} });
    //     }
    //     else if (to.path == '/') {
    //         console.log('from root path');
    //         next({
    //             name: 'index',
    //             // force: true,
    //             // query: { redirect: to.fullPath },
    //             params: {lang: 'az'}
    //         });
    //     }
    //     else{
    //         console.log('else route');
    //         next();
    //     }
    // }

    else {
        console.log('4', to);
        next();
    }

});

router.beforeResolve((to, from, next) => {
    if (to.name) {
        NProgress.start()
        next();
    } else {
        next();
    }
});

router.afterEach(() => {
    NProgress.done();
});


export default router;
